import { UserAvatar } from "@/components/Avatar";

export default function PresenceList({ users }) {
  return (
    <div className="w-72 p-3 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-2xl space-y-1 max-h-80 overflow-y-auto">
      <p className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wide px-1 mb-2">
        Online — {users.length}
      </p>
      {users.length === 0 && <p className="text-xs text-slate-400 dark:text-slate-500 px-1 py-2">Belum ada yang online</p>}
      {users.map((u, i) => (
        <div
          key={i}
          data-testid={`presence-user-${u.username}`}
          className="flex items-center gap-3 px-1 py-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800/50"
        >
          <UserAvatar username={u.username} avatar={u.avatar} size={32} showStatus status="online" />
          <span className="text-sm text-slate-700 dark:text-slate-200 font-medium truncate">{u.username}</span>
        </div>
      ))}
    </div>
  );
}
